import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfSwiperTab from '@elem/ui/ef-swiper-tab';
import EFXStream from 'elem/ui-assets/icons/unregular/EFXStream';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { useProductStore } from './../../../ProductProvider';
import imgLocale1 from './imgs/img1';
import imgLocale2 from './imgs/img2';
import imgLocale3 from './imgs/img3';
import imgLocale4 from './imgs/img4';
import imgLocale5 from './imgs/img5';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale = 'us' } = useRouter();
    const { pageStatus } = useProductStore();
    const IS_NA_SITES = ['us', 'ca', 'br', 'mx'].includes(locale);
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'es', 'it', 'ph'].includes(locale);
    const [active, setActive] = useState(0);
    const hasLogo = IS_EU_SITES && active === 0;
    const img1 = imgLocale1[locale] || imgLocale1['eu'];
    const img2 = imgLocale2[locale] || imgLocale2['eu'];
    const img3 = imgLocale3[locale] || imgLocale3['eu'];
    const img4 = imgLocale4[locale] || imgLocale4['eu'];
    const img5 = imgLocale5[locale] || imgLocale5['eu'];

    const configs = {
        navigation: false,
        hasInfo: true,
        gap: 0,
        // initialSlide: IS_NA_SITES ? 1 : 0,
        lists: [
            {
                pc: img1.pc,
                h5: img1.h5,
                tab: t('D_item1_tab'),
                title: t.rich('D_item1_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('D_item1_desc'),
            },
            {
                pc: img2.pc,
                h5: img2.h5,
                tab: t('D_item2_tab'),
                title: t.rich('D_item2_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('D_item2_desc'),
            },
            {
                pc: img3.pc,
                h5: img3.h5,
                tab: t('D_item3_tab'),
                title: t.rich('D_item3_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('D_item3_desc'),
                linkText: ['de', 'uk'].includes(locale) ? t('D_item3_link_text') : '',
                linkUrl: ['de', 'uk'].includes(locale) ? t('D_item3_link_url') : '',
            },
            {
                pc: img4.pc,
                h5: img4.h5,
                tab: t('D_item4_tab'),
                title: t.rich('D_item4_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('D_item4_desc'),
            },
            {
                pc: img5.pc,
                h5: img5.h5,
                tab: t('D_item5_tab'),
                title: t.rich('D_item5_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('D_item5_desc'),
            },
        ],
        callback: (n: number) => setActive(n),
    };

    if (IS_EU_SITES) {
        configs.lists = [
            {
                pc: img1.pc,
                h5: img1.h5,
                tab: t('D_item1_tab'),
                title: t.rich('D_item1_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('D_item1_desc'),
            },
            {
                pc: img2.pc,
                h5: img2.h5,
                tab: t('D_item2_tab'),
                title: t.rich('D_item2_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('D_item2_desc'),
            },
            {
                pc: img4.pc,
                h5: img4.h5,
                tab: t('D_item4_tab'),
                title: t.rich('D_item4_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('D_item4_desc'),
            },
            {
                pc: img5.pc,
                h5: img5.h5,
                tab: t('D_item5_tab'),
                title: t.rich('D_item5_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('D_item5_desc'),
            },
            {
                pc: img3.pc,
                h5: img3.h5,
                tab: t('D_item3_tab'),
                title: t.rich('D_item3_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('D_item3_desc'),
                linkText: ['de', 'uk'].includes(locale) ? t('D_item3_link_text') : '',
                linkUrl: ['de', 'uk'].includes(locale) ? t('D_item3_link_url') : '',
            },
        ];
    }

    if (IS_NA_SITES) {
        configs.lists = [
            {
                pc: img3.pc,
                h5: img3.h5,
                tab: t('D_item3_tab'),
                //title: t('D_item3_title'),
                title: t.rich('D_item3_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('D_item3_desc'),
                linkUrl: !['statusA', 'statusB', 'statusC', 'statusD'].includes(pageStatus)
                    ? `https://${locale}.ecoflow.com/products/smart-generator-3000-dual-fuel`
                    : ' ',
                linkText: !['statusA', 'statusB', 'statusC', 'statusD'].includes(pageStatus) ? t('common_more') : t('common_coming'),
            },
            {
                pc: img4.pc,
                h5: img4.h5,
                tab: t('D_item4_tab'),
                //title: t('D_item4_title'),
                title: t.rich('D_item4_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('D_item4_desc'),
                linkUrl: `https://${locale}.ecoflow.com/products/800w-alternator-charger`,
                linkText: t('common_more'),
            },
            {
                pc: img5.pc,
                h5: img5.h5,
                tab: t('D_item5_tab'),
                //title: t('D_item5_title'),
                title: t.rich('D_item5_title', {
                    b: (tx: string) => <span className="b">{tx}</span>,
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                }),
                desc: t('D_item5_desc'),
            },
        ];
    }

    return (
        <div className={styles.TheComp}>
            <EfSpec className={IS_NA_SITES ? 'spec-m' : 'spec-x'} />
            {hasLogo && <EFXStream className="logo" />}
            <EfSwiperTab {...configs} />
            <EfSpec className="spec-x" />
        </div>
    );
}
